module.exports = __webpack_public_path__ + "assets/08489b59899946c1e2c54971ad2a74fd.png";